<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import ProcedureDetail from "../components/procedures/ProcedureDetail.svelte";
	import type { ProcedureDetailProps } from "./ProcedureDetailProps.js";

	const props: ProcedureDetailProps = $props();
	const { procedure, procedures } = props;
</script>

<Layout>
	<ProcedureDetail {procedure} {procedures} />
</Layout>
